export default class InvestigatorCreateInvestigatorController {
  constructor($q, $state, $scope, AuthenticationService, UIService, InvestigatorService, Investigador, Genero, Pais, InvestigadorTipoInvestigador, InvestigadorTipo, InvestigadorGrauAcademico, InvestigadorHValue, InvestigadorCitacao, InvestigadorContratacao, InvestigadorAtividade, InvestigadorParticipacaoGestao, InvestigadorEntradaSaida, InvestigadorInstituicao, InvestigadorGrupoInvestigacao, GrauAcademico, TipoParticipacaoGestao, Instituicao, Categoria, GrupoInvestigacao) {
    this.$q = $q;
    this.state = $state;
    this.$scope = $scope;
    this.UI = UIService;
    this.user = AuthenticationService.getUser();
    this.InvestigatorService = InvestigatorService;
    this.loaded = false;
    this.simnao = [{ name: "Sim", value: 1 }, { name: "Não", value: 0 }];
    this.Investigador = Investigador;
    this.Genero = Genero;
    this.Pais = Pais;
    this.InvestigadorTipoInvestigador = InvestigadorTipoInvestigador;
    this.InvestigadorTipo = InvestigadorTipo;
    this.InvestigadorGrauAcademico = InvestigadorGrauAcademico;
    this.InvestigadorHValue = InvestigadorHValue;
    this.InvestigadorCitacao = InvestigadorCitacao;
    this.InvestigadorContratacao = InvestigadorContratacao;
    this.InvestigadorAtividade = InvestigadorAtividade;
    this.InvestigadorParticipacaoGestao = InvestigadorParticipacaoGestao;
    this.InvestigadorEntradaSaida = InvestigadorEntradaSaida;
    this.InvestigadorInstituicao = InvestigadorInstituicao;
    this.InvestigadorGrupoInvestigacao = InvestigadorGrupoInvestigacao;
    this.GrauAcademico = GrauAcademico;
    this.TipoParticipacaoGestao = TipoParticipacaoGestao;
    this.Instituicao = Instituicao;
    this.Categoria = Categoria;
    this.GrupoInvestigacao = GrupoInvestigacao;
    this.generos = null;
    this.nacionalidades = null;

    // To be used in orcid form
    this.optOrcid = {
      valid: true, // If orcidId typed is valid
      used: false, // If orcidId is already used in the database
      db: true, // If orcidId was looked up in database
      online: true // If orcidId was looked up online
    };

    this.emptyData = {
      form: 1,
      details: {},
      blockedFields: {},

      tiposInvestigador: [],
      grausAcademicos: [],
      hValues: [],
      citacoes: [],
      contratacoes: [],
      atividades: [],
      participacaoGestao: [],
      entradasSaidas: [],
      instituicoes: [],
      gruposInvestigacao: [],

      auxSuperiorHierarquico1: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxSuperiorHierarquico2: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxGenero: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxNacionalidade: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxDevelopingCountry: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}}
    };

    // Configuration for date picker data
    this.dateOptions = {
      dataNascimento: {format: 'DD/MM/YYYY'}
    };

    // Load data to fill ui-selects
    this.loadAuxData();

    $scope.$watch(() => {
      return this.data;
    }, (val) => {
      if (angular.isDefined(val)) {
        localStorage.setItem('ISR_SGI_InvestigadorNewForm', JSON.stringify(val));
      }
    }, true);
  }

  loadAuxData = () => {
    this.Genero.find({
    }).$promise.then((generos) => {
      this.generos = generos;
      this.Pais.find({
        filter: {
          order: 'ordem ASC'
        }
      }).$promise.then((nacionalidades) => {
        this.nacionalidades = nacionalidades;
        this.Investigador.find({}).$promise.then(investigadores => {
          investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
          this.investigadores = investigadores;
          this.loadDataFromStorage();
          this.loaded = true;
        }).catch(e => {
          this.UI.addToast("Erro ao carregar Superiores Hierárquicos. Verifique a ligação");
          this.state.go('app.investigator.list');
        });
      }).catch(err => {
        console.log(err);
        this.UI.addToast("Erro ao carregar nacionalidades. Verifique a sua ligação");
        this.state.go('app.investigator.list');
      });
    }).catch(err => {
      console.log(err);
      this.UI.addToast("Erro ao carregar géneros. Verifique a sua ligação");
      this.state.go('app.investigator.list');
    });
  };

  // Infinite Scroll magic
  addMoreItems = (infiniteScroll) => {
    infiniteScroll.currentItems += infiniteScroll.numToAdd;
  };

  loadDataFromStorage = () => {
    if (localStorage.getItem('ISR_SGI_InvestigadorNewForm')) {
      let storageData = JSON.parse(localStorage.getItem('ISR_SGI_InvestigadorNewForm'));
      // Only use what is required
      this.data = {};
      if (storageData.form) this.data.form = storageData.form; else this.data.form = angular.copy(this.emptyData.form);
      if (storageData.details) this.data.details = storageData.details; else this.data.details = angular.copy(this.emptyData.details);
      if (storageData.blockedFields) this.data.blockedFields = storageData.blockedFields; else this.data.blockedFields = angular.copy(this.emptyData.blockedFields);

      if (storageData.tiposInvestigador) this.data.tiposInvestigador = storageData.tiposInvestigador; else this.data.tiposInvestigador = angular.copy(this.emptyData.tiposInvestigador);
      if (storageData.grausAcademicos) this.data.grausAcademicos = storageData.grausAcademicos; else this.data.grausAcademicos = angular.copy(this.emptyData.grausAcademicos);
      if (storageData.hValues) this.data.hValues = storageData.hValues; else this.data.hValues = angular.copy(this.emptyData.hValues);
      if (storageData.citacoes) this.data.citacoes = storageData.citacoes; else this.data.citacoes = angular.copy(this.emptyData.citacoes);
      if (storageData.contratacoes) this.data.contratacoes = storageData.contratacoes; else this.data.contratacoes = angular.copy(this.emptyData.contratacoes);
      if (storageData.atividades) this.data.atividades = storageData.atividades; else this.data.atividades = angular.copy(this.emptyData.atividades);
      if (storageData.participacaoGestao) this.data.participacaoGestao = storageData.participacaoGestao; else this.data.participacaoGestao = angular.copy(this.emptyData.participacaoGestao);
      if (storageData.entradasSaidas) this.data.entradasSaidas = storageData.entradasSaidas; else this.data.entradasSaidas = angular.copy(this.emptyData.entradasSaidas);
      if (storageData.instituicoes) this.data.instituicoes = storageData.instituicoes; else this.data.instituicoes = angular.copy(this.emptyData.instituicoes);
      if (storageData.gruposInvestigacao) this.data.gruposInvestigacao = storageData.gruposInvestigacao; else this.data.gruposInvestigacao = angular.copy(this.emptyData.gruposInvestigacao);

      if (storageData.auxSuperiorHierarquico1) this.data.auxSuperiorHierarquico1 = storageData.auxSuperiorHierarquico1; else this.data.auxSuperiorHierarquico1 = angular.copy(this.emptyData.auxSuperiorHierarquico1);
      if (storageData.auxSuperiorHierarquico2) this.data.auxSuperiorHierarquico2 = storageData.auxSuperiorHierarquico2; else this.data.auxSuperiorHierarquico2 = angular.copy(this.emptyData.auxSuperiorHierarquico2);
      if (storageData.auxGenero) this.data.auxGenero = storageData.auxGenero; else this.data.auxGenero = angular.copy(this.emptyData.auxGenero);
      if (storageData.auxNacionalidade) this.data.auxNacionalidade = storageData.auxNacionalidade; else this.data.auxNacionalidade = angular.copy(this.emptyData.auxNacionalidade);
      if (storageData.auxDevelopingCountry) this.data.auxDevelopingCountry = storageData.auxDevelopingCountry; else this.data.auxDevelopingCountry = angular.copy(this.emptyData.auxDevelopingCountry);
    } else {
      this.data = angular.copy(this.emptyData);
    }
    this.state.transitionTo('app.investigator.new.' + this.data.form);
  };

  setForm = num => {
    this.data.form = num;
    this.state.transitionTo('app.investigator.new.' + this.data.form);
  };

  cleanForm = () => {
    // Clean filled data
    this.data = angular.copy(this.emptyData);
    this.state.transitionTo('app.investigator.new.' + this.data.form);
  };

  submit = () => {
    this.isValid().then(() => {
      this.loaded = false;
      // Create Investigador and related data
      this.data.details.id = 0;
      this.data.details.auxSuperiorHierarquico1Id = this.data.auxSuperiorHierarquico1.selected ? this.data.auxSuperiorHierarquico1.selected.id : null;
      this.data.details.auxSuperiorHierarquico2Id = this.data.auxSuperiorHierarquico2.selected ? this.data.auxSuperiorHierarquico2.selected.id : null;
      this.data.details.nacionalidadeId = this.data.auxNacionalidade.selected.id;
      this.data.details.generoId = this.data.auxGenero.selected.id;
      this.data.details.developingCountry = this.data.auxDevelopingCountry.selected.value;
      this.data.details.criadoPorId = this.user.id;
      this.data.details.dataCriacao = moment().format();
      this.data.details.atualizadoPorId = this.user.id;
      this.data.details.dataAtualizacao = moment().format();
      this.data.details.ok = 1; // Profile ok

      this.Investigador.create(this.data.details).$promise.then((investigador) => {

        let deferTipoInvestigador = this.$q.defer();
        // Create all Tipos de Investigador
        this.InvestigatorService.createMultipleData(this.InvestigadorTipoInvestigador, this.data.tiposInvestigador, investigador.id, 'investigadorId').then((x) => {
          deferTipoInvestigador.resolve({ok: true});
        }).catch(err => {
          deferTipoInvestigador.resolve({ok: false, output: 'Tipo de Investigador'});
        });

        // Create all Graus Academicos
        let deferGrauAcademico = this.$q.defer();
        this.InvestigatorService.createMultipleData(this.InvestigadorGrauAcademico, this.data.grausAcademicos, investigador.id, 'investigadorId').then((x) => {
          deferGrauAcademico.resolve({ok: true});
        }).catch(err => {
          deferGrauAcademico.resolve({ok: false, output: 'Grau Académico'});
        });

        // Create all H Values
        let deferHValue = this.$q.defer();
        this.InvestigatorService.createMultipleData(this.InvestigadorHValue, this.data.hValues, investigador.id, 'investigadorId').then((x) => {
          deferHValue.resolve({ok: true});
        }).catch(err => {
          deferHValue.resolve({ok: false, output: 'H Value'});
        });

        // Create all Citacoes
        let deferCitacao = this.$q.defer();
        this.InvestigatorService.createMultipleData(this.InvestigadorCitacao, this.data.citacoes, investigador.id, 'investigadorId').then((x) => {
          deferCitacao.resolve({ok: true});
        }).catch(err => {
          deferCitacao.resolve({ok: false, output: 'Citaçoes'});
        });

        // Create all Participacao Gestao
        let deferParticipacaoGestao = this.$q.defer();
        this.InvestigatorService.createMultipleData(this.InvestigadorParticipacaoGestao, this.data.participacaoGestao, investigador.id, 'investigadorId').then((x) => {
          deferParticipacaoGestao.resolve({ok: true});
        }).catch(err => {
          deferParticipacaoGestao.resolve({ok: false, output: 'Participação em órgãos de Gestão'});
        });

        // Create all Contratações
        let deferContratacoes = this.$q.defer();
        this.InvestigatorService.createMultipleData(this.InvestigadorContratacao, this.data.contratacoes, investigador.id, 'investigadorId').then((x) => {
          deferContratacoes.resolve({ok: true});
        }).catch(err => {
          deferContratacoes.resolve({ok: false, output: 'Contratações'});
        });

        // Create all Atividades
        let deferAtividades = this.$q.defer();
        this.InvestigatorService.createMultipleData(this.InvestigadorAtividade, this.data.atividades, investigador.id, 'investigadorId').then((x) => {
          deferAtividades.resolve({ok: true});
        }).catch(err => {
          deferAtividades.resolve({ok: false, output: 'Períodos de Atividade'});
        });

        // Create all Entrada Saida
        let deferEntradaSaida = this.$q.defer();
        this.InvestigatorService.createMultipleData(this.InvestigadorEntradaSaida, this.data.entradasSaidas, investigador.id, 'investigadorId').then((x) => {
          deferEntradaSaida.resolve({ok: true});
        }).catch(err => {
          deferEntradaSaida.resolve({ok: false, output: 'Entrada / Saída do ISR'});
        });

        // Create all Instituicoes
        let deferInstituicao = this.$q.defer();
        this.InvestigatorService.createMultipleData(this.InvestigadorInstituicao, this.data.instituicoes, investigador.id, 'investigadorId').then((x) => {
          deferInstituicao.resolve({ok: true});
        }).catch(err => {
          deferInstituicao.resolve({ok: false, output: 'Instituição'});
        });

        // Create all Grupos Investigação
        let deferGrupoInvestigacao = this.$q.defer();
        this.InvestigatorService.createMultipleData(this.InvestigadorGrupoInvestigacao, this.data.gruposInvestigacao, investigador.id, 'investigadorId').then((x) => {
          deferGrupoInvestigacao.resolve({ok: true});
        }).catch(err => {
          deferGrupoInvestigacao.resolve({ok: false, output: 'Grupo de Investigação'});
        });

        let promises = [deferTipoInvestigador.promise, deferGrauAcademico.promise, deferHValue.promise,
          deferCitacao.promise, deferContratacoes.promise, deferAtividades.promise, deferParticipacaoGestao.promise,
          deferEntradaSaida.promise, deferInstituicao.promise, deferGrupoInvestigacao.promise];

        // After all multiple data information is created/settled
        this.$q.all(promises).then((res) => {
          this.UI.addToast("Investigador criado com sucesso");

          let error = this.createdMultipleDataOk(res);
          if (error) {
            let errorMessage = "Investigador criado, mas ocorreram erros a inserir os seguintes dados: " + error + ". Por favor verifique e adicione-os manualmente";
            alert = this.UI.showAlert(errorMessage);
            alert.finally(() => {
              // Clear data for next time
              this.data = angular.copy(this.emptyData);
              localStorage.removeItem('ISR_SGI_InvestigadorNewForm');

              // Redirect to details view so it can be filled
              this.state.go('app.investigator.details', {id: investigador.id});
            });
          } else {
            // Clear data for next time
            this.data = angular.copy(this.emptyData);
            localStorage.removeItem('ISR_SGI_InvestigadorNewForm');

            // Redirect to list view
            this.state.go('app.investigator.list');
          }
        }).catch(err => { // Should never happen, since resolving everything...
          console.log(err);
          alert = this.UI.showAlert("Investigador criado, mas ocorreram erros a inserir alguns dados. Por favor verifique e adicione-os manualmente");
          alert.finally(() => {
            // Clear data for next time
            this.data = angular.copy(this.emptyData);
            localStorage.removeItem('ISR_SGI_InvestigadorNewForm');

            // Redirect to details view so it can be filled
            this.state.go('app.investigator.details', {id: investigador.id});
          });
        });
      }).catch((error) => {
        console.log(error);
        this.UI.showAlert("Erro ao criar investigador. Verifique a ligação");
        this.loaded = true;
      });
    }).catch((x) => {
      // Nothing to do. Just fix values and resubmit...
    });
  };

  // Check if there was an error adding multiple data, and return a string with the bad inserted data
  createdMultipleDataOk = (res) => {
    let output = '';
    if (res && res.length > 0) {
      res.forEach(r => {
        if (!r.ok) output += r.output + ", ";
      });
      // If there's data, remove trailing ", "
      if (output.length > 0)
        return output.slice(0, -2);
    }
    return output.length === 0 ? null : output;
  };


  isValid = () => {
    let validDefer = this.$q.defer();
    let v = true;

    // Check if investigador data is well defined
    // ORCID ID
    if (v && (!this.InvestigatorService.isValidOrcidId(this.data.details.orcidId))) {
      this.UI.addToast("ORCID ID do Investigador inválido");
      v = false;
      validDefer.reject();
    }
    // Nome
    if (v && (!this.data.details.nome || this.data.details.nome.length === 0)) {
      this.UI.addToast("Nome do Investigador não preenchido");
      v = false;
      validDefer.reject();
    }
    // Nome Preferido
    if (v && (!this.data.details.nomePreferido || this.data.details.nomePreferido.length === 0)) {
      this.UI.addToast("Nome Preferido do Investigador não preenchido");
      v = false;
      validDefer.reject();
    }
    // Slug
    if (v && (!this.InvestigatorService.isValidSlug(this.data.details.slug))) {
      this.UI.addToast("Slug inválido, use apenas letras minúsculas, números e hífenes, sem espaços nem acentos.");
      v = false;
      validDefer.reject();
    }
    // Data de Nascimento
    if (v && (!this.data.details.dataNascimento || !moment(this.data.details.dataNascimento).isValid())) {
      this.UI.addToast("Data de Nascimento de Investigador inválida");
      v = false;
      validDefer.reject();
    }
    // Email - If exists, needs to be correct
    if (v && (this.data.details.email && !this.InvestigatorService.validEmail(this.data.details.email))) {
      this.UI.addToast("Email inválido");
      v = false;
      validDefer.reject();
    }
    // Email Alternativo - If exists, needs to be correct
    if (v && (this.data.details.emailAlternativo && !this.InvestigatorService.validEmail(this.data.details.emailAlternativo))) {
      this.UI.addToast("Email alternativo inválido");
      v = false;
      validDefer.reject();
    }
    // Género
    if (v && (!this.data.auxGenero || !this.data.auxGenero.selected || !this.InvestigatorService.isValidDataId(this.generos, this.data.auxGenero.selected.id))) {
      this.UI.addToast("Género de Investigador inválido");
      v = false;
      validDefer.reject();
    }
    // Nacionalidade
    if (v && (!this.data.auxNacionalidade || !this.data.auxNacionalidade.selected || !this.InvestigatorService.isValidDataId(this.nacionalidades, this.data.auxNacionalidade.selected.id))) {
      this.UI.addToast("Nacionalidade de Investigador inválida");
      v = false;
      validDefer.reject();
    }

    // Superiores Hierárquicos não podem ser o mesmo
    if (v && (this.data.auxSuperiorHierarquico1.selected && this.data.auxSuperiorHierarquico2.selected && this.data.auxSuperiorHierarquico1.selected.id === this.data.auxSuperiorHierarquico2.selected.id)) {
      this.UI.addToast("Superiores Hierárquicos 1 e 2 são iguais. Altere ou apague um deles.");
      v = false;
      validDefer.reject();
    }

    // ResearcherId
    if (v && (this.data.details.researcherId && !this.InvestigatorService.isValidURL(this.data.details.researcherId))) {
      this.UI.addToast("ResearcherID deve ser um URL válido");
      v = false;
      validDefer.reject();
    }
    // ResearcherId
    if (v && (this.data.details.googleScholar && !this.InvestigatorService.isValidURL(this.data.details.googleScholar))) {
      this.UI.addToast("GoogleScholar deve ser um URL válido");
      v = false;
      validDefer.reject();
    }
    // ResearcherId
    if (v && (this.data.details.degois && !this.InvestigatorService.isValidURL(this.data.details.degois))) {
      this.UI.addToast("Degóis deve ser um URL válido");
      v = false;
      validDefer.reject();
    }
    // From developing country?
    if (v && (!this.data.auxDevelopingCountry || !this.data.auxDevelopingCountry.selected)) {
      this.UI.addToast("Valor 'From developing country' inválido");
      v = false;
      validDefer.reject();
    }

    if (v && (this.data.entradasSaidas.length === 0)) {
      this.UI.addToast("Entrada/Saída não preenchido");
      v = false;
      validDefer.reject();
    }

    if (v && (this.data.tiposInvestigador.length === 0)) {
      this.UI.addToast("Tipo de Investigador não preenchido");
      v = false;
      validDefer.reject();
    }

    if (v && (this.data.atividades.length === 0)) {
      this.UI.addToast("Período de Atividade não preenchido");
      v = false;
      validDefer.reject();
    }

    if (v && (this.data.grausAcademicos.length === 0)) {
      this.UI.addToast("Grau Académico não preenchido");
      v = false;
      validDefer.reject();
    }

    // Only validate multidata if all static data is valid, otherwise no point first
    if (v) {
      // VALIDATE ASYNC DATA
      let idData = [];

      // Add static async data

      // If slug is filled, we need to check if it exists already too
      idData.push({
        field: 'slug',
        value: this.data.details.slug,
        model: this.Investigador,
        resolveOnExist: false,
        error: "Já existe este slug associado a outro investigador"
      });

      idData.push({
        field: 'orcidId',
        value: this.data.details.orcidId,
        model: this.Investigador,
        resolveOnExist: false, // It's resolved if it doesn't find one
        error: "ORCID ID já está registado no SGI"
      });

      idData.push({
        field: 'id',
        value: this.data.auxGenero.selected.id,
        model: this.Genero,
        resolveOnExist: true, // It's resolved if it finds one
        error: "Género de Investigador inexistente"
      }, {
        field: 'id',
        value: this.data.auxNacionalidade.selected.id,
        model: this.Pais,
        resolveOnExist: true, // It's resolved if it finds one
        error: "Nacionalidade de Investigador inexistente"
      });

      // Add multi async data to verify
      this.data.grausAcademicos.forEach(x => {
        idData.push({
          field: 'id',
          value: x.grauAcademicoId,
          model: this.GrauAcademico,
          resolveOnExist: true, // It's resolved if it finds one
          error: "Grau Académico inexistente"
        });
      });
      this.data.instituicoes.forEach(x => {
        idData.push({
          field: 'id',
          value: x.instituicaoId,
          model: this.Instituicao,
          resolveOnExist: true, // It's resolved if it finds one
          error: "Instituição inexistente"
        }, {
          field: 'id',
          value: x. categoriaId,
          model: this.Categoria,
          resolveOnExist: true, // It's resolved if it finds one
          error: "Categoria inexistente"
        });
      });
      this.data.participacaoGestao.forEach(x => {
        idData.push({
          field: 'id',
          value: x.tipoId,
          model: this.TipoParticipacaoGestao,
          resolveOnExist: true, // It's resolved if it finds one
          error: "Tipo de participação em gestão inexistente"
        });
      });
      this.data.tiposInvestigador.forEach(x => {
        idData.push({
          field: 'id',
          value: x.tipoId,
          model: this.InvestigadorTipo,
          resolveOnExist: true, // It's resolved if it finds one
          error: "Tipo de investigador inexistente"
        });
      });
      this.data.gruposInvestigacao.forEach(x => {
        idData.push({
          field: 'id',
          value: x.grupoInvestigacaoId,
          model: this.GrupoInvestigacao,
          resolveOnExist: true, // It's resolved if it finds one
          error: "Grupo de Investigação inexistente"
        });
      });


      let wait = this.UI.showWaiting();
      // Verify all the async data
      this.InvestigatorService.validateMultiData(idData).then(x => {
        wait.close();
        validDefer.resolve();
      }).catch(() => {
        wait.close();
        validDefer.reject();
      });
    }
    return validDefer.promise;
  };

  // Called when typing orciId
  // Checks if OrcidID is valid, then checks online data if it's already used and if not imports and assigns data,
  // blocking what was obtained and unblocking what wasn't
  setOrcidId = () => {
    // If OrcidId is empty, we have to disable errors
    if (!this.data.details.orcidId || this.data.details.orcidId.length === 0) {
      // Unlock fields that were blocked
      this.clearOrcidForm();
      this.data.blockedFields = {};
      // Reset all other errors
      this.optOrcid.valid = true;
      this.optOrcid.used = false;
      this.optOrcid.db = true;
      this.optOrcid.online = true;
      return;
    }
    // Check if it's well constructed
    this.optOrcid.valid = this.InvestigatorService.isValidOrcidId(this.data.details.orcidId);

    if (this.optOrcid.valid) {
      this.InvestigatorService.fieldValueExists('orcidId', this.data.details.orcidId, this.Investigador).then((exists) => {
        this.optOrcid.db = true;
        this.optOrcid.used = exists;
        if (!this.optOrcid.used) {

          // Used to fetch online in ISR - Not used anymore
          // this.Investigador.getIsrDataByOrcidId({orcidId: this.data.details.orcidId}).$promise.then((data) => {
          //   this.optOrcid.online = true;
          //   // TODO - How to store legacyPersonId safely?
          //   if (data.nome) {
          //     this.data.details.nome = data.nome;
          //     this.data.blockedFields.nome = true;
          //   }
          //   if (data.email) {
          //     this.data.details.email = data.email;
          //     this.data.blockedFields.email = true;
          //   }
          //   if (data.sexo) { // 'MA' ou 'FE', converte para índice
          //     let genero = this.generos.find(x => x.designacao.toUpperCase().startsWith(data.sexo));
          //     if (genero) {
          //       this.data.auxGenero.selected = angular.copy(genero);
          //       this.data.blockedFields.genero = true;
          //     } else {
          //       this.data.auxGenero.selected = this.generos.find(x => x.designacao === 'Outro');
          //       if (this.data.auxGenero.selected) {
          //         this.data.blockedFields.genero = true;
          //       }
          //     }
          //   }
          //   if (data.dataNascimento) {
          //     this.data.details.dataNascimento = data.dataNascimento;
          //     this.data.blockedFields.dataNascimento = true;
          //   }
          //   if (data.chavePublicaFct) {
          //     this.data.details.chavePublicaFct = data.chavePublicaFct;
          //     this.data.blockedFields.chavePublicaFct = true;
          //   }
          //   // if (data.nORCID) {
          //   //
          //   // }
          //   if (data.cienciaID) {
          //     this.data.details.cienciaId = data.cienciaID;
          //     this.data.blockedFields.cienciaId = true;
          //   }
          //   if (data.nacionalidade) {
          //     let nacionalidadeId = this.getNacionalidadeFromIsr(data.nacionalidade);
          //     let nacionalidade = this.nacionalidades.find(x => x.id === nacionalidadeId);
          //     if (nacionalidade) {
          //       this.data.auxNacionalidade.selected = angular.copy(nacionalidade);
          //       this.data.blockedFields.nacionalidade = true;
          //     } // Else does nothing, select it yourself
          //   }
          //   this.data.details.legacyPersonId = data.id;
          //
          // }).catch(error => {
          //   console.log(error);
          //   this.optOrcid.online = false;
          // });

          // Get some data from ORCID directly
          this.Investigador.getOrcidData({
            orcidId: this.data.details.orcidId,
            data: 'person'
          }).$promise.then(data => {
            // Update that it was checked online
            this.optOrcid.online = true;
            if (data.nome) {
              this.data.details.nome = data.nome;
              this.data.blockedFields.nome = true;
              this.data.details.nomePreferido = data.nome;
              this.data.details.slug = this.InvestigatorService.stringToSlug(data.nome);
            } else {
              this.data.blockedFields.nome = false;
            }
            if (data.email) {
              this.data.details.email = data.email;
              this.data.blockedFields.email = true;
            } else {
              this.data.blockedFields.email = false;
            }
          }).catch(error => {
            console.log(error);
            this.optOrcid.online = false;
          });
        } else { // If ORCID ID is already used, clear orcidIdLookup values
          this.optOrcid.db = true;
          this.optOrcid.online = true;
        }
      }).catch(error => {
        console.log(error);
        this.optOrcid.db = false;
        this.optOrcid.online = true; // If the first doesn't work, clear whatever value is in the second
      });
    } else { // Unlock fields that were blocked
      this.data.blockedFields = {};
      // Reset all other errors
      this.optOrcid.used = false;
      this.optOrcid.db = true;
      this.optOrcid.online = true;
    }
  };

  // Translates between ISR database to paisId
  getNacionalidadeFromIsr = (id) => {
    switch(id) {
      case 1: return 620;
      case 2: return 724;
      case 3: return 250;
      case 4: return 380;
      case 5: return 826;
      case 6: return 76;
      case 7: return 24;
      case 8: return 508;
      case 9: return 132;
      case 10: return 626;
      default: return null;
    }
  };

  // Check if OrcidId form entry has error, true - error, false - ok
  orcidIdFormError = () => {
    return (!this.optOrcid.valid || this.optOrcid.used || !this.optOrcid.db || !this.optOrcid.online);
  };

  // Clear all fields changed by orcidId
  clearOrcidForm = () => {
    // Clear all data changed by orcidId
    Object.keys(this.data.blockedFields).forEach(k => {
      delete this.data.details[k];
    });

    if (this.data.blockedFields.genero)
      this.data.auxGenero.selected = undefined;
    if (this.data.blockedFields.nacionalidade) {
      this.data.auxNacionalidade.selected = undefined;
      this.data.auxDevelopingCountry.selected = undefined;
    }
  };

  updateSlug = () => {
    this.data.details.slug = this.InvestigatorService.stringToSlug(this.data.details.nomePreferido);
  };

  // Checks for valid dates in forms. If one is not valid moment, return false
  // TODO - Bug when deleting time and readding
  validFormDates = (dates) => {
    if (dates != null && dates.length > 0) {
      for (let i = 0; i < dates.length; i++) {
        if (!moment.isMoment(dates[i])) {console.log("Not moment"); return false;}
        if (!dates[i].isValid()) {console.log("Not valid"); return false;}
      }
      return true;
    } else {
      return false;
    }
  };

  // MULTIPLE DATA CRUDs
  // Adicionar um novo grau académico para investigador
  addGrauAcademico = () => {
    let wait = this.UI.showWaiting();
    this.GrauAcademico.find({}).$promise.then((grausAcademicos) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.grau.academico.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.grauAcademico = {};
          $scope.label = "Novo Grau Académico para Investigador";
          $scope.grausAcademicos = grausAcademicos;

          $scope.auxGrau = {
            selected: undefined,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          $scope.dateOptions = {
            data: {format: 'DD/MM/YYYY'}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxGrau && ok.grauAcademico) {
          let item = angular.copy(ok.grauAcademico);
          item.data = item.data.format(); // Use text instead of moment
          item.grauAcademicoId = ok.auxGrau.selected.id;
          item.grauAcademico = angular.copy(ok.auxGrau.selected);

          this.data.grausAcademicos.push(item);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler graus académicos. Verifique a sua ligação");
    });
  };

  // Edita informação de grau académico para investigador
  editGrauAcademico = (x) => {
    let wait = this.UI.showWaiting();
    this.GrauAcademico.find({}).$promise.then((grausAcademicos) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.grau.academico.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.grauAcademico = angular.copy(x);
          $scope.label = "Editar Grau Académico para Investigador";
          $scope.grausAcademicos = grausAcademicos;

          $scope.auxGrau = {
            selected: $scope.grauAcademico.grauAcademico,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.dateOptions = {
            data: {format: 'DD/MM/YYYY'}
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxGrau && ok.grauAcademico) {
          // Update data without replacing the variable x (so it's still an element of the array)
          x.data = ok.grauAcademico.data.format(); // Use text instead of moment
          x.observacoes = ok.grauAcademico.observacoes;
          x.grauAcademicoId = ok.auxGrau.selected.id;
          x.grauAcademico = angular.copy(ok.auxGrau.selected);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler graus académicos. Verifique a sua ligação");
    });
  };

  // Remove Grau Académico com índice index
  removeGrauAcademico = (index) => {
    if (index < this.data.grausAcademicos.length) {
      this.data.grausAcademicos.splice(index, 1);
    }
  };


  // Adicionar uma nova citação para investigador
  addCitacao = () => {
    let options = {
      size: 'lg',
      template: require('./edit.citacao.dialog.html'),
      controller: ['$scope', '$dialog', ($scope, $dialog) => {
        $scope.citacao = {};
        $scope.label = "Nova Contagem de Citações para Investigador";

        // Current year as max be able to add citacoes
        $scope.year = moment().format('YYYY');

        // Use today as default
        $scope.citacao.dataAtualizacao = moment();
        $scope.dateOptions = {
          dataAtualizacao: {
            format: 'DD/MM/YYYY',
            maxDate: moment()
          }
        };

        $scope.ok = () => {
          $dialog.close($scope);
        };

        $scope.cancel = () => {
          $dialog.dismiss('cancel');
        };
      }]
    };
    let dialogEdit = this.UI.showDialog(options);
    dialogEdit.then(ok => {
      if (ok.citacao) {
        let item = angular.copy(ok.citacao);
        item.dataAtualizacao = item.dataAtualizacao.format(); // Use text instead of moment
        this.data.citacoes.push(item);
      }
    });
  };

  // Edita informação de citação para investigador
  editCitacao = (x) => {
    let options = {
      size: 'lg',
      template: require('./edit.citacao.dialog.html'),
      controller: ['$scope', '$dialog', ($scope, $dialog) => {
        $scope.citacao = angular.copy(x);
        $scope.label = "Editar Contagem de Citações para Investigador";

        // Current year as max be able to add citacoes
        $scope.year = moment().format('YYYY');
        $scope.dateOptions = {
          dataAtualizacao: {
            format: 'DD/MM/YYYY',
            maxDate: moment()
          }
        };

        $scope.ok = () => {
          $dialog.close($scope);
        };

        $scope.cancel = () => {
          $dialog.dismiss('cancel');
        };
      }]
    };
    let dialogEdit = this.UI.showDialog(options);
    dialogEdit.then(ok => {
      if (ok.citacao) {
        x.ano = ok.citacao.ano;
        x.numCitacoesAno = ok.citacao.numCitacoesAno;
        x.numCitacoesTotal = ok.citacao.numCitacoesTotal;
        x.dataAtualizacao = ok.citacao.dataAtualizacao.format(); // Use text instead of moment
      }
    });
  };

  // Remove citação com índice index
  removeCitacao = (index) => {
    if (index < this.data.citacoes.length) {
      this.data.citacoes.splice(index, 1);
    }
  };


  // Adicionar uma novo h-value para investigador
  addHValue = () => {
    let options = {
      size: 'lg',
      template: require('./edit.hvalue.dialog.html'),
      controller: ['$scope', '$dialog', ($scope, $dialog) => {
        $scope.hValue = {};
        $scope.label = "Novo H-Value para o Investigador";

        // Use today as default
        $scope.hValue.dataAtualizacao = moment();
        $scope.dateOptions = {
          dataAtualizacao: {
            format: 'DD/MM/YYYY',
            maxDate: moment()
          }
        };

        $scope.ok = () => {
          $dialog.close($scope);
        };

        $scope.cancel = () => {
          $dialog.dismiss('cancel');
        };
      }]
    };
    let dialogEdit = this.UI.showDialog(options);
    dialogEdit.then(ok => {
      if (ok.hValue) {
        let item = angular.copy(ok.hValue);
        item.dataAtualizacao = item.dataAtualizacao.format(); // Use text instead of moment
        this.data.hValues.push(item);
      }
    });
  };

  // Edita informação de h-value para investigador
  editHValue = (x) => {
    let options = {
      size: 'lg',
      template: require('./edit.hvalue.dialog.html'),
      controller: ['$scope', '$dialog', ($scope, $dialog) => {
        $scope.hValue = angular.copy(x);
        $scope.label = "Editar h-value para Investigador";

        // Current year as max be able to add h-value
        $scope.year = moment().format('YYYY');
        $scope.dateOptions = {
          dataAtualizacao: {
            format: 'DD/MM/YYYY',
            maxDate: moment()
          }
        };

        $scope.ok = () => {
          $dialog.close($scope);
        };

        $scope.cancel = () => {
          $dialog.dismiss('cancel');
        };
      }]
    };
    let dialogEdit = this.UI.showDialog(options);
    dialogEdit.then(ok => {
      if (ok.hValue) {
        // Update data without replacing the variable g (so it's still an element of the array)
        x.ano = ok.hValue.ano;
        x.hValue = ok.hValue.hValue;
        x.dataAtualizacao = ok.hValue.dataAtualizacao.format(); // Use text instead of moment
        x.observacoes = ok.hValue.observacoes;
      }
    });
  };

  // Remove h-value com índice index
  removeHValue = (index) => {
    if (index < this.data.hValues.length) {
      this.data.hValues.splice(index, 1);
    }
  };


  // Adicionar uma nova entrada/saída para investigador
  addEntradaSaida = () => {
    let options = {
      size: 'lg',
      template: require('./edit.entrada.saida.dialog.html'),
      controller: ['$scope', '$dialog', ($scope, $dialog) => {
        $scope.entradaSaida = {};
        $scope.label = "Nova Entrada/Saída do ISR para o Investigador";

        $scope.removeDate = this.UI.removeDate;
        $scope.dateOptions = {
          dataEntrada: {format: 'DD/MM/YYYY'},
          dataSaida: {format: 'DD/MM/YYYY'}
        };
        $scope.validFormDates = this.validFormDates;
        $scope.ok = () => {
          $dialog.close($scope);
        };

        $scope.cancel = () => {
          $dialog.dismiss('cancel');
        };
      }]
    };
    let dialogEdit = this.UI.showDialog(options);
    dialogEdit.then(ok => {
      if (ok.entradaSaida) {
        let item = angular.copy(ok.entradaSaida);
        item.dataEntrada = item.dataEntrada.format(); // Use text instead of moment
        if (item.dataSaida != null && item.dataSaida.isValid()) // null, undefined or invalid date
          item.dataSaida = item.dataSaida.format(); // Use text instead of moment
        else
          item.dataSaida = null;
        this.data.entradasSaidas.push(item);
      }
    });
  };

  // Edita informação de entrada/saída para investigador
  editEntradaSaida = (x) => {
    let options = {
      size: 'lg',
      template: require('./edit.entrada.saida.dialog.html'),
      controller: ['$scope', '$dialog', ($scope, $dialog) => {
        $scope.entradaSaida = angular.copy(x);
        $scope.label = "Entrada/Saída do ISR para o Investigador";

        $scope.removeDate = this.UI.removeDate;
        $scope.dateOptions = {
          dataEntrada: {format: 'DD/MM/YYYY'},
          dataSaida: {format: 'DD/MM/YYYY'}
        };

        $scope.ok = () => {
          $dialog.close($scope);
        };

        $scope.cancel = () => {
          $dialog.dismiss('cancel');
        };
      }]
    };
    let dialogEdit = this.UI.showDialog(options);
    dialogEdit.then(ok => {
      if (ok.entradaSaida) {
        // Update data without replacing the variable e (so it's still an element of the array)
        x.dataEntrada = ok.entradaSaida.dataEntrada.format(); // Use text instead of moment
        if (ok.entradaSaida.dataSaida != null && ok.entradaSaida.dataSaida.isValid())
          x.dataSaida = ok.entradaSaida.dataSaida.format(); // Use text instead of moment
        else
          x.dataSaida = null;
        x.observacoes = ok.entradaSaida.observacoes;
      }
    });
  };

  // Remove entrada/saída com índice index
  removeEntradaSaida = (index) => {
    if (index < this.data.entradasSaidas.length) {
      this.data.entradasSaidas.splice(index, 1);
    }
  };


  // Adicionar um novo tipo de investigador para investigador
  addTipoInvestigador = () => {
    let wait = this.UI.showWaiting();
    this.InvestigadorTipo.find({}).$promise.then((tipos) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.tipo.investigador.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.tipoInvestigador = {};
          $scope.label = "Novo Tipo para Investigador";
          $scope.tipos = tipos;

          $scope.auxTipo = {
            selected: undefined,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          $scope.removeDate = this.UI.removeDate;
          $scope.dateOptions = {
            dataInicio: {format: 'DD/MM/YYYY'},
            dataFim: {format: 'DD/MM/YYYY'}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxTipo && ok.tipoInvestigador) {
          let item = angular.copy(ok.tipoInvestigador);
          item.dataInicio = item.dataInicio.format(); // Use text instead of moment
          if (item.dataFim != null && item.dataFim.isValid()) // null, undefined or invalid date
            item.dataFim = item.dataFim.format(); // Use text instead of moment
          else
            item.dataFim = null;
          item.tipoId = ok.auxTipo.selected.id;
          item.tipoInvestigador = angular.copy(ok.auxTipo.selected);
          this.data.tiposInvestigador.push(item);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler tipos de invesigador. Verifique a sua ligação");
    });
  };

  // Edita informação de tipo de investigador
  editTipoInvestigador = (x) => {
    let wait = this.UI.showWaiting();
    this.InvestigadorTipo.find({}).$promise.then((tipos) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.tipo.investigador.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.tipoInvestigador = angular.copy(x);
          $scope.label = "Editar Tipo de Investigador";
          $scope.tipos = tipos;

          $scope.auxTipo = {
            selected: $scope.tipoInvestigador.tipoInvestigador,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.removeDate = this.UI.removeDate;
          $scope.dateOptions = {
            dataInicio: {format: 'DD/MM/YYYY'},
            dataFim: {format: 'DD/MM/YYYY'}
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxTipo && ok.tipoInvestigador) {
          // Update data without replacing the variable g (so it's still an element of the array)
          x.dataInicio = ok.tipoInvestigador.dataInicio.format(); // Use text instead of moment
          if (ok.tipoInvestigador.dataFim != null && ok.tipoInvestigador.dataFim.isValid()) // null, undefined or invalid date
            x.dataFim = ok.tipoInvestigador.dataFim.format(); // Use text instead of moment
          else
            x.dataFim = null;
          x.observacoes = ok.tipoInvestigador.observacoes;
          x.tipoId = ok.auxTipo.selected.id;
          x.tipoInvestigador = angular.copy(ok.auxTipo.selected);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler tipos de investigador. Verifique a sua ligação");
    });
  };

  // Remove Tipo de Investigador com índice index
  removeTipoInvestigador = (index) => {
    if (index < this.data.tiposInvestigador.length) {
      this.data.tiposInvestigador.splice(index, 1);
    }
  };

  // Adicionar uma nova contratação para investigador
  addContratacao = () => {
    let options = {
      size: 'lg',
      template: require('./edit.contratacao.dialog.html'),
      controller: ['$scope', '$dialog', ($scope, $dialog) => {
        $scope.contratacao = {};
        $scope.label = "Nova Contratação ISR para Investigador";

        $scope.removeDate = this.UI.removeDate;
        $scope.dateOptions = {
          dataInicio: {format: 'DD/MM/YYYY'},
          dataFim: {format: 'DD/MM/YYYY'}
        };

        $scope.ok = () => {
          $dialog.close($scope);
        };

        $scope.cancel = () => {
          $dialog.dismiss('cancel');
        };
      }]
    };
    let dialogEdit = this.UI.showDialog(options);
    dialogEdit.then(ok => {
      if (ok.contratacao) {
        let item = angular.copy(ok.contratacao);
        item.dataInicio = item.dataInicio.format(); // Use text instead of moment
        if (item.dataFim != null && item.dataFim.isValid()) // null, undefined or invalid date
          item.dataFim = item.dataFim.format(); // Use text instead of moment
        else
          item.dataFim = null;
        this.data.contratacoes.push(item);
      }
    });
  };

  // Edita informação de contratação para investigador
  editContratacao = (x) => {
    let options = {
      size: 'lg',
      template: require('./edit.contratacao.dialog.html'),
      controller: ['$scope', '$dialog', ($scope, $dialog) => {
        $scope.contratacao = angular.copy(x);
        $scope.label = "Editar Contratação ISR para Investigador";

        $scope.removeDate = this.UI.removeDate;
        $scope.dateOptions = {
          dataInicio: {format: 'DD/MM/YYYY'},
          dataFim: {format: 'DD/MM/YYYY'}
        };

        $scope.ok = () => {
          $dialog.close($scope);
        };

        $scope.cancel = () => {
          $dialog.dismiss('cancel');
        };
      }]
    };
    let dialogEdit = this.UI.showDialog(options);
    dialogEdit.then(ok => {
      if (ok.contratacao) {
        // Update data without replacing the variable x (so it's still an element of the array)
        x.dataInicio = ok.contratacao.dataInicio.format(); // Use text instead of moment
        if (ok.contratacao.dataFim != null && ok.contratacao.dataFim.isValid()) // null, undefined or invalid date
          x.dataFim = ok.contratacao.dataFim.format(); // Use text instead of moment
        else
          x.dataFim = null;
        x.observacoes = ok.contratacao.observacoes;
      }
    });
  };

  // Remove Contratação com índice index
  removeContratacao = (index) => {
    if (index < this.data.contratacoes.length) {
      this.data.contratacoes.splice(index, 1);
    }
  };


  // Adicionar um novo período de atividade para investigador
  addAtividade = () => {
    let options = {
      size: 'lg',
      template: require('./edit.atividade.dialog.html'),
      controller: ['$scope', '$dialog', ($scope, $dialog) => {
        $scope.contratacao = {};
        $scope.label = "Novo Perído de Atividade para Investigador no ISR";

        $scope.removeDate = this.UI.removeDate;
        $scope.dateOptions = {
          dataInicio: {format: 'DD/MM/YYYY'},
          dataFim: {format: 'DD/MM/YYYY'}
        };

        $scope.ok = () => {
          $dialog.close($scope);
        };

        $scope.cancel = () => {
          $dialog.dismiss('cancel');
        };
      }]
    };
    let dialogEdit = this.UI.showDialog(options);
    dialogEdit.then(ok => {
      if (ok.atividade) {
        let item = angular.copy(ok.atividade);
        item.dataInicio = item.dataInicio.format(); // Use text instead of moment
        if (item.dataFim != null && item.dataFim.isValid()) // null, undefined or invalid date
          item.dataFim = item.dataFim.format(); // Use text instead of moment
        else
          item.dataFim = null;
        this.data.atividades.push(item);
      }
    });
  };

  // Edita período de atividade para investigador ISR
  editAtividade = (x) => {
    let options = {
      size: 'lg',
      template: require('./edit.atividade.dialog.html'),
      controller: ['$scope', '$dialog', ($scope, $dialog) => {
        $scope.atividade = angular.copy(x);
        $scope.label = "Editar Perído de Atividade para Investigador no ISR";

        $scope.removeDate = this.UI.removeDate;
        $scope.dateOptions = {
          dataInicio: {format: 'DD/MM/YYYY'},
          dataFim: {format: 'DD/MM/YYYY'}
        };

        $scope.ok = () => {
          $dialog.close($scope);
        };

        $scope.cancel = () => {
          $dialog.dismiss('cancel');
        };
      }]
    };
    let dialogEdit = this.UI.showDialog(options);
    dialogEdit.then(ok => {
      if (ok.atividade) {
        // Update data without replacing the variable x (so it's still an element of the array)
        x.dataInicio = ok.atividade.dataInicio.format(); // Use text instead of moment
        if (ok.atividade.dataFim != null && ok.atividade.dataFim.isValid()) // null, undefined or invalid date
          x.dataFim = ok.atividade.dataFim.format(); // Use text instead of moment
        else
          x.dataFim = null;
        x.observacoes = ok.atividade.observacoes;
      }
    });
  };

  // Remove Período de Atividade com índice index
  removeAtividade = (index) => {
    if (index < this.data.atividades.length) {
      this.data.atividades.splice(index, 1);
    }
  };

  matchAtividadeEntradaSaida = () => {
    if (this.data.entradasSaidas.length > 0) {
      let atividadesExist = "";
      if (this.data.atividades.length > 0) // Make sure you want to remove the already existing atividades
        atividadesExist = " Irá também eliminar o(s) período(s) já introduzido(s). ";
      let warningString = "Esta operação irá criar períodos de atividade coincidentes com os períodos de entrada/saída do ISR." + atividadesExist + " Tem a certeza?";
      let alert = this.UI.showConfirm(warningString);
      alert.then(() => {

        // Clean old atividades if they exist
        this.data.atividades = [];
        // Cycle through entradasSaidas and build atividade
        this.data.entradasSaidas.forEach(es => {
          this.data.atividades.push({
            dataInicio: es.dataEntrada,
            dataFim: es.dataSaida,
            observacoes: es.observacoes
          });
        });
      });
    }
  };


  // Adicionar uma nova participação em gestão para investigador
  addParticipacaoGestao = () => {
    let wait = this.UI.showWaiting();
    this.TipoParticipacaoGestao.find({}).$promise.then((tipos) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.participacao.gestao.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.participacao = {};
          $scope.label = "Nova Participação em Gestão do ISR para Investigador";
          $scope.tipos = tipos;

          $scope.auxTipo = {
            selected: undefined,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          $scope.removeDate = this.UI.removeDate;
          $scope.dateOptions = {
            dataInicio: {format: 'DD/MM/YYYY'},
            dataFim: {format: 'DD/MM/YYYY'}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxTipo && ok.participacao) {
          let item = angular.copy(ok.participacao);
          item.dataInicio = item.dataInicio.format(); // Use text instead of moment
          if (item.dataFim != null && item.dataFim.isValid()) // null, undefined or invalid date
            item.dataFim = item.dataFim.format(); // Use text instead of moment
          else
            item.dataFim = null;
          item.tipoId = ok.auxTipo.selected.id;
          item.tipoParticipacao = angular.copy(ok.auxTipo.selected);
          this.data.participacaoGestao.push(item);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler tipos de participação. Verifique a sua ligação");
    });
  };

  // Edita informação de participação em gestão para investigador
  editParticipacaoGestao = (x) => {
    let wait = this.UI.showWaiting();
    this.TipoParticipacaoGestao.find({}).$promise.then((tipos) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.participacao.gestao.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.participacao = angular.copy(x);
          $scope.label = "Editar Participação em Gestão do ISR para Investigador";
          $scope.tipos = tipos;

          $scope.auxTipo = {
            selected: $scope.participacao.tipoParticipacao,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.removeDate = this.UI.removeDate;
          $scope.dateOptions = {
            dataInicio: {format: 'DD/MM/YYYY'},
            dataFim: {format: 'DD/MM/YYYY'}
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxTipo && ok.participacao) {
          // Update data without replacing the variable x (so it's still an element of the array)
          x.dataInicio = ok.participacao.dataInicio.format(); // Use text instead of moment
          if (ok.participacao.dataFim != null && ok.participacao.dataFim.isValid()) // null, undefined or invalid date
            x.dataFim = ok.participacao.dataFim.format(); // Use text instead of moment
          else
            x.dataFim = null;
          x.observacoes = ok.participacao.observacoes;
          x.tipoId = ok.auxTipo.selected.id;
          x.tipoParticipacao = angular.copy(ok.auxTipo.selected);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler tipos de participação. Verifique a sua ligação");
    });
  };

  // Remove Grau Académico com índice index
  removeParticipacaoGestao = (index) => {
    if (index < this.data.participacaoGestao.length) {
      this.data.participacaoGestao.splice(index, 1);
    }
  };


  // Adicionar uma nova instituição para investigador
  addInstituicao = () => {
    let wait = this.UI.showWaiting();
    this.Instituicao.find({}).$promise.then((instituicoes) => {
      this.Categoria.find({}).$promise.then((categorias) => {
        wait.close();
        let options = {
          size: 'lg',
          template: require('./edit.instituicao.dialog.html'),
          controller: ['$scope', '$dialog', ($scope, $dialog) => {
            $scope.instituicao = {};
            $scope.label = "Nova Instituição para Investigador";
            $scope.instituicoes = instituicoes;
            $scope.categorias = categorias;

            $scope.auxInstituicao = {
              selected: undefined,
              infiniteScroll: {numToAdd: 20, currentItems: 20}
            };

            $scope.auxCategoria = {
              selected: undefined,
              infiniteScroll: {numToAdd: 20, currentItems: 20}
            };

            $scope.removeDate = this.UI.removeDate;
            $scope.dateOptions = {
              dataEntrada: {format: 'DD/MM/YYYY'},
              dataSaida: {format: 'DD/MM/YYYY'}
            };

            // Infinite Scroll magic
            $scope.addMoreItems = (infiniteScroll) => {
              infiniteScroll.currentItems += infiniteScroll.numToAdd;
            };

            $scope.ok = () => {
              $dialog.close($scope);
            };

            $scope.cancel = () => {
              $dialog.dismiss('cancel');
            };
          }]
        };
        let dialogEdit = this.UI.showDialog(options);
        dialogEdit.then(ok => {
          if (ok.auxInstituicao && ok.auxCategoria && ok.instituicao) {
            let item = angular.copy(ok.instituicao);
            item.dataEntrada = item.dataEntrada.format(); // Use text instead of moment
            if (item.dataSaida != null && item.dataSaida.isValid()) // null, undefined or invalid date
              item.dataSaida = item.dataSaida.format(); // Use text instead of moment or null
            else
              item.dataSaida = null;
            item.instituicaoId = ok.auxInstituicao.selected.id;
            item.instituicao = angular.copy(ok.auxInstituicao.selected);
            item.categoriaId = ok.auxCategoria.selected.id;
            item.categoria = angular.copy(ok.auxCategoria.selected);

            this.data.instituicoes.push(item);
          }
        });
      }).catch((error) => {
        wait.close();
        console.log(error);
        this.UI.addToast("Não foi possível ler Categorias. Verifique a sua ligação");
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler Instituições. Verifique a sua ligação");
    });
  };

  // Edita informação de instituição para investigador
  editInstituicao = (x) => {
    let wait = this.UI.showWaiting();
    this.Instituicao.find({}).$promise.then((instituicoes) => {
      this.Categoria.find({}).$promise.then((categorias) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.instituicao.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.instituicao = angular.copy(x);
          $scope.label = "Editar Instituição para Investigador";
          $scope.instituicoes = instituicoes;
          $scope.categorias = categorias;

          $scope.auxInstituicao = {
            selected: $scope.instituicao.instituicao,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          $scope.auxCategoria = {
            selected: $scope.instituicao.categoria,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.removeDate = this.UI.removeDate;
          $scope.dateOptions = {
            dataEntrada: {format: 'DD/MM/YYYY'},
            dataSaida: {format: 'DD/MM/YYYY'}
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = (x) => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxInstituicao && ok.auxCategoria && ok.instituicao) {
          // Update data without replacing the variable x (so it's still an element of the array)
          x.dataEntrada = ok.instituicao.dataEntrada.format(); // Use text instead of moment
          if (ok.instituicao.dataSaida != null && ok.instituicao.dataSaida.isValid())  // null, undefined or invalid date
            x.dataSaida = ok.instituicao.dataSaida.format(); // Use text instead of moment or null
          else
            x.dataSaida = null;
          x.observacoes = ok.instituicao.observacoes;
          x.instituicaoId = ok.auxInstituicao.selected.id;
          x.instituicao = angular.copy(ok.auxInstituicao.selected);
          x.categoriaId = ok.auxCategoria.selected.id;
          x.categoria = angular.copy(ok.auxCategoria.selected);
        }
      });
      }).catch((error) => {
        wait.close();
        console.log(error);
        this.UI.addToast("Não foi possível ler Categorias. Verifique a sua ligação");
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler Instituições. Verifique a sua ligação");
    });
  };

  // Remove Instituição com índice index
  removeInstituicao = (index) => {
    if (index < this.data.instituicoes.length) {
      this.data.instituicoes.splice(index, 1);
    }
  };

  // Adicionar um novo grupo de investigação para investigador
  addGrupoInvestigacao = () => {
    let wait = this.UI.showWaiting();
    this.GrupoInvestigacao.find({}).$promise.then((gruposInvestigacao) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.grupo.investigacao.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.grupoInvestigacao = {};
          $scope.label = "Adicionar Grupo de Investigação para Investigador";
          $scope.gruposInvestigacao = gruposInvestigacao;

          $scope.auxGrupoInvestigacao = {
            selected: undefined,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          $scope.removeDate = this.UI.removeDate;
          $scope.dateOptions = {
            dataEntrada: {format: 'DD/MM/YYYY'},
            dataSaida: {format: 'DD/MM/YYYY'}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxGrupoInvestigacao && ok.grupoInvestigacao) {
          let item = angular.copy(ok.grupoInvestigacao);
          item.dataEntrada = item.dataEntrada.format(); // Use text instead of moment
          if (item.dataSaida != null && item.dataSaida.isValid()) // null, undefined or invalid date
            item.dataSaida = item.dataSaida.format(); // Use text instead of moment or null
          else
            item.dataSaida = null;
          item.grupoInvestigacaoId = ok.auxGrupoInvestigacao.selected.id;
          item.grupoInvestigacao = angular.copy(ok.auxGrupoInvestigacao.selected);

          this.data.gruposInvestigacao.push(item);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler Grupos de Investigação. Verifique a sua ligação");
    });
  };

  // Edita informação de instituição para investigador
  editGrupoInvestigacao = (x) => {
    let wait = this.UI.showWaiting();
    this.GrupoInvestigacao.find({}).$promise.then((gruposInvestigacao) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.grupo.investigacao.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.grupoInvestigacao = angular.copy(x);
          $scope.label = "Editar Grupo de Investigação para Investigador";
          $scope.gruposInvestigacao = gruposInvestigacao;

          $scope.auxGrupoInvestigacao = {
            selected: $scope.grupoInvestigacao.grupoInvestigacao,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.removeDate = this.UI.removeDate;
          $scope.dateOptions = {
            dataEntrada: {format: 'DD/MM/YYYY'},
            dataSaida: {format: 'DD/MM/YYYY'}
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = (x) => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxGrupoInvestigacao && ok.grupoInvestigacao) {
          // Update data without replacing the variable x (so it's still an element of the array)
          x.dataEntrada = ok.grupoInvestigacao.dataEntrada.format(); // Use text instead of moment
          if (ok.grupoInvestigacao.dataSaida != null && ok.grupoInvestigacao.dataSaida.isValid())  // null, undefined or invalid date
            x.dataSaida = ok.grupoInvestigacao.dataSaida.format(); // Use text instead of moment or null
          else
            x.dataSaida = null;
          x.observacoes = ok.grupoInvestigacao.observacoes;
          x.grupoInvestigacaoId = ok.auxGrupoInvestigacao.selected.id;
          x.grupoInvestigacao = angular.copy(ok.auxGrupoInvestigacao.selected);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler Grupos de Investigação. Verifique a sua ligação");
    });
  };

  // Remove Instituição com índice index
  removeGrupoInvestigacao = (index) => {
    if (index < this.data.gruposInvestigacao.length) {
      this.data.gruposInvestigacao.splice(index, 1);
    }
  };

}

InvestigatorCreateInvestigatorController.$inject = ['$q', '$state', '$scope', 'AuthenticationService', 'UIService', 'InvestigatorService', 'Investigador', 'Genero', 'Pais', 'InvestigadorTipoInvestigador', 'InvestigadorTipo', 'InvestigadorGrauAcademico', 'InvestigadorHValue', 'InvestigadorCitacao', 'InvestigadorContratacao', 'InvestigadorAtividade', 'InvestigadorParticipacaoGestao', 'InvestigadorEntradaSaida', 'InvestigadorInstituicao', 'InvestigadorGrupoInvestigacao', 'GrauAcademico', 'TipoParticipacaoGestao', 'Instituicao', 'Categoria', 'GrupoInvestigacao'];
